<template>
  <v-toolbar
    fixed
    flat
    scroll-off-screen
    :scroll-threshold="50"
    class="transparent">


    <!-- <v-toolbar-title>
         <img :src="require('../assets/fuzzcv-logo.png')"
         height="30"
         class="mt-3"
         alt="fuzzcv curriculum vitae CV automatique en ligne logo"
         >
         </v-toolbar-title> -->
    <v-toolbar-side-icon class="hidden-sm-and-up"
                         color="white"
                         @click.stop="toggleDrawer()"
    ></v-toolbar-side-icon>


    <v-btn
      flat
      large
      color="white"
      to="/conseils"
      class="hidden-xs-only"
    >
      Conseils CV
    </v-btn>

    <v-spacer></v-spacer>

    <v-btn
      large
      outline
      round
      color="white"
      to="/login"
      class="hidden-xs-only"
    >
      connection
    </v-btn>

    <v-btn
      large
      round
      color="success"
      to='/register'
      class="hidden-xs-only"
    >
      Inscription
    </v-btn>

  </v-toolbar>
</template>

<script>

 import { mapActions, mapState } from 'vuex';
 export default {

   components: {

   },
   computed: {
     ...mapState('sidebarLanding', [
       'open',
       'clipped',
       'fixed',
       'permanent',
       'mini',
     ]),
   },
   methods : {
     ...mapActions('sidebarLanding', [
       'toggleDrawer',
     ]),
   },
 }
</script>
